import { EspecialUnoService } from 'src/app/modulos/catalogos-proces/services/especial-uno.service';
import { ProcesoService } from '../../services/proceso.service';
import { AreaElementoService } from '../../services/area.elemento.service';
import { AreaService } from './../../../catalogos-admin/services/area.service';
import { IpPublicService } from '../../../../services/ip-public.service';
import { Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, Validators, UntypedFormGroup, FormArray, FormControl } from '@angular/forms';
import { AlertService } from '../../../../services/alert.service';
import { ModalService } from '../../../../services/modal.service';
import { DataTableDirective } from 'angular-datatables';
import { ConstantsCatalogosIdService } from 'src/app/services/constants-catalogos-id.service';
import { ObjetivoService } from '../../services/objetivo.service';
import { ComunService } from 'src/app/modulos/catalogos-proces/services/comun.service';
import { EquipoGerencialService } from 'src/app/modulos/catalogos-proces/services/equipo.gerencial.service';
import { ParticipanteElementoService } from '../../services/participante.elemento.service';
import { Subject, forkJoin, map, mergeMap } from 'rxjs';
import { DatePipe } from '@angular/common';
import { DesempenioProcesoService } from '../../services/desempenio-proceso.service';
import { IndicadoresService } from './../../services/indicadores.service';
import { AppState } from 'src/app/app.reducer';
import { Store } from '@ngrx/store';
import { validadorFechaIntervalo } from 'src/app/helpers/validator-form';
import { UsuarioRedux } from 'src/app/models/usuario.model';
@Component({
  selector: 'app-proceso',
  templateUrl: './proceso.component.html',
  styleUrls: ['./proceso.component.css'],
})
export class ProcesoComponent implements OnInit, OnDestroy {
  breadCrumbItems = [
    { label: 'Formulación Planes' },
    { label: 'Elementos' },
    { label: 'Procesos', active: true },
  ];
  public formProceso!: UntypedFormGroup;
  public formSelectAnio!: UntypedFormGroup;
  public formSubmitted = false;
  public currentAmbiente!: any;
  public ipAddress!: string;
  public buffer: any;
  public nameModal: string = 'PROCESOS';
  public modalEle: string = 'modalEle';
  public dataProcesos: any[] = [];
  public dataAreaElement: any[] = [];
  public dataParticipanteElemento: any[] = [];
  public dataObjetivo!: any; // trae data de objetivos
  public dataAreas!: any; // trae data de areas del Ambiente
  public dataAreasChecked: any = []; //data para Area
  public dataAreasProcess: any = [];
  public dataTipoParticpacion: any = [];
  public dataResponsableProceso: any = [];
  public dataElementosParticpantes: any = [];
  public dataEquipoGerencial!: any;
  public dataEstrategias!: any;
  public dataCatComun!: any; // trae data catalogo especialUno
  public dataCatEspecialUno!: any; // trae data catalogo comun
  public dataTipoProceso!: any; // trae data catalogo especial uno tipo de proceso
  public dataEstrategiasObjetivos: any = []; // trae data catalogo comun tipo de proceso
  public dataEstrategiasProcess: any = []; // trae data catalogo comun tipo de proceso
  public dataObjetivoProceso: any = [];
  public dataMejoras!: any; // trae data catalogo comun Mejoras
  public dataEstrategiasMain!: any; // trae data de estrategias
  public nombreUnidad!: any;
  private idDeleteRegister: number = 0;
  public selectItems: any[] = [];
  public selectItems1: any[] = [];
  public selectItems2: any[] = [];
  public estadoActivo: number = 1;
  public tituloModal: string = 'DESEMPEÑO DE PROCESOS';
  public modalDesempenioProceso: string = 'modalDesempenioProceso';
  public desripcionProceso!: any;
  public nombreEstrategia!: any;
  public nombreObjetivo!: any;
  public nombreTipoProceso!: any;
  public nombreTipoCliente!: any;
  public idSprNivel: number = 0;
  public nombreMejoras!: any;
  public idSprAmbiente!: number;
  public idSprUsuarioApp: number = 0;
  public nivelSelect!: number;
  public dataPlanesAnios: any = [];
  public idSprPlanAnio: number = 0;
  public idSprAnio: number = 0;
  public idSprTargetAnio: number = 0;
  public dataAnios: any = [];
  public anioActual: string = '';
  public idSprSelectAnio: number = 0;
  public hoy = new Date();
  public pipe = new DatePipe('en-US');
  public inputs = [{ value: '' }];
  public modalOpen = false;
  public edit: boolean = false;
  public areaElementoGuardado = [];
  public idProceso!: any;
  public dataAllParticipantesElemento = [];
  public desempenio = [];
  public contador = 3000;
  public contador1 = 500;
  public textoAreaValue1 = '';
  public textoAreaValue = '';
  idSprPlanInstitucionalRedux: any;
  public planAnioSeleccionadoRedux: any = null;
  dataAniosObj: any[] = [];
  currentUserRedux: UsuarioRedux = null;
  public objetivoSeleccionadoCombo: any = null;
  fechaIniciObjetivo: any;
  fechaFinObjetivo: any;
  public dataResponsable: any = [];
  opcionSeleccionada: string = 'si';
  public openFechaCertifi: boolean = true;
  inputsAnteriores = [];
  public patrocinadorOriginal: any;
  public guardarEquipoGerencialSeleccionado: any;
  public dataParticipanteELemento: any[];
  public idSprParticipanteElemento: number = 0;
  public dataParticipantesElemento: any;
  public dataPersonalElementoP!: any;
  public idSprParticipanteElementoM!: any;
  public opciones: any[] = []

  public idSprNivelN5 = ConstantsCatalogosIdService.ID_COMUNES_NIVEL_5; //id del  nivel N5
  public idRecursivoCliente = ConstantsCatalogosIdService.ID_COMUNES_TIPO_CLIENTE; //id de tipo de cliente del catalogo comun
  public idRecursivoMejoras = ConstantsCatalogosIdService.ID_COMUNES_MEJORAS; //id tipo de mejoras del catalago comun
  public idSprTipoProceso = ConstantsCatalogosIdService.ID_ESPECIAL_UNO_TIPO_PROCESO;
  public idRolResponsable = ConstantsCatalogosIdService.ID_COMUNES_RESPONSABLE;

  dtOptions: DataTables.Settings = {};
  dtTrigger: Subject<any> = new Subject<any>();
  @ViewChild(DataTableDirective, { static: false })
  dtElement: DataTableDirective;
  isDtInitialized: boolean = false;

  @ViewChild('modalChild') myModal: any;
  readonly constant = ConstantsCatalogosIdService;

  constructor(
    public store: Store<AppState>,
    private fb: FormBuilder,
    private procesoService: ProcesoService,
    private alert: AlertService,
    private ip: IpPublicService,
    public modal: ModalService,
    private objetivosService: ObjetivoService,
    private comunService: ComunService,
    private especialUnoService: EspecialUnoService,
    private areaServcie: AreaService,
    private equipoGerencialService: EquipoGerencialService,
    private areaELemService: AreaElementoService,
    private desempenioProcesoService: DesempenioProcesoService,
    private indicadoresService: IndicadoresService,
    private participanteElementoService: ParticipanteElementoService,
  ) {
    this.buffer = localStorage.getItem('currentUser');
    this.currentAmbiente = JSON.parse(this.buffer);
    this.nombreUnidad = this.currentAmbiente.nombreUnidad;
    this.selectItems = [
      { value: 1, label: 'Activo' },
      { value: 2, label: 'Inactivo' },
    ];
    this.selectItems1 = [
      { value: 1, label: 'Si' },
      { value: 2, label: 'No' },
    ];
    this.selectItems2 = [
      { value: 1, label: 'Si' },
      { value: 2, label: 'No' },
    ];
  }

  onSelectChange() {
    // Habilitar o deshabilitar la fecha de certificación según la opción seleccionada
    const procesoCertificado = this.formProceso.get('procesoCertificado').value;
    if (procesoCertificado === '1') {
      this.formProceso.get('fechaCertificacion').enable();
    } else {
      this.formProceso.get('fechaCertificacion').disable();
    }
  }

  get procesoForm() {
    return this.formProceso.controls;
  }

  setDataTable() {
    this.dtOptions = {
      pagingType: 'full_numbers',
      pageLength: 10,
      destroy: true,
      language: {
        //url: '//cdn.datatables.net/plug-ins/1.13.4/i18n/es-ES.json',
      },
    };
  }

  setForm() {
    this.formProceso = this.fb.group({
      idSprProceso: [],
      idSprAreaProceso: [],
      idSprArea: new FormArray([]),
      idSprObjetivo: ['', [Validators.required]],
      idSprTipoProceso: ['', [Validators.required]],
      idSprAmbiente: [],
      idSprMejoras: ['', [Validators.required]],
      idSprParticipanteElemento: [],
      idSprTipoCliente: ['', [Validators.required]],
      idSprEquipoGerencial: ['', [Validators.required]],
      nombre: ['', [Validators.required]],
      descripcion: ['', [Validators.required]],
      producto: ['', [Validators.required]],
      disparador: ['', [Validators.required]],
      fechaInicio: ['', [Validators.required, validadorFechaIntervalo(this.fechaIniciObjetivo, this.fechaFinObjetivo),],],
      fechaFin: ['', [Validators.required, validadorFechaIntervalo(this.fechaIniciObjetivo, this.fechaFinObjetivo),],],
      tiempoCiclo: ['', [Validators.required]],
      numeroPersonaAsignada: ['', [Validators.required]],
      procesoDocumentado: ['', [Validators.required]],
      procesoCertificado: ['', [Validators.required]],
      fechaCertificacion: [[validadorFechaIntervalo(this.fechaIniciObjetivo, this.fechaFinObjetivo)],],
      estado: ['', [Validators.required]],
    });
  }

  /* REVISAR PARA ELIMINAR NUEVO METODO DATA TABLE
  @ViewChild('myTable') myTable: ElementRef;
  ngAfterViewInit(): void {
    $(this.myTable.nativeElement).DataTable({
      paging: true,
      searching: true,
      // other options...
    });
  }*/

  ngOnInit(): void {
    this.store.select('globalApp').subscribe((response) => {
      this.planAnioSeleccionadoRedux = response.planAniosSeleccionado;
      this.idSprPlanAnio = response.planAniosSeleccionado.idSprPlanAnio
      this.idSprNivel = response.ambienteSeleccionado.nivel.idSprNivel;
      this.idSprAmbiente = response.ambienteSeleccionado.idSprAmbiente;
      this.fechaIniciObjetivo = response.planAniosSeleccionado.fechaInicio;
      this.fechaFinObjetivo = response.planAniosSeleccionado.fechaFin;
      this.initApp();
    });

    this.store.select('usuarioApp').subscribe((response) => {
      this.currentUserRedux = response.currentUser;
      this.idSprUsuarioApp = response.currentUser.idSprUsuario;
    });
  }

  initApp() {
    this.getIpPublic();
    this.setDataTable();
    this.setForm();
    this.listTipoCliente();
    this.listTipoProceso();
    this.listMejoras();
    this.listAreas();
    this.getDataParticipantes();
    this.getDataAll();
  }

  getDataAll() {
    forkJoin([
      this.objetivosService.list('?idSprAmbiente=' + this.idSprAmbiente + '&idSprPlanAnio=' + this.idSprPlanAnio + '&estado=' + this.estadoActivo),
      this.procesoService.list('?idSprAmbiente=' + this.idSprAmbiente),
      this.areaELemService.list('?estado=' + this.estadoActivo),
    ]).pipe(
      map(([dataObjetivo, dataProcesos, dataAreaElement]) => {
        this.dataObjetivo = dataObjetivo;
        this.dataProcesos = dataProcesos;
        this.dataAreaElement = dataAreaElement;
        this.mapeoObjetivoProceso();
      })
    )
      .subscribe();
  }

  mapeoObjetivoProceso() {
    let dataProcess = [];
    let areaProceso: any = [];
    for (let i = 0; i < this.dataObjetivo.length; i++) {
      for (let j = 0; j < this.dataProcesos.length; j++) {
        if (this.dataObjetivo[i].idSprObjetivo === this.dataProcesos[j].idSprObjetivo && this.dataObjetivo[i].estado == 1) {
          for (let k = 0; k < this.dataAreaElement.length; k++) {
            if (this.dataAreaElement[k].idSprProceso == this.dataProcesos[j].idSprProceso) {
              areaProceso.push({
                idSprArea: this.dataAreaElement[k].idSprArea,
                //nombre: this.dataAreaElement[k].nombre,
              });
            }
          }
          dataProcess.push({
            idSprProceso: this.dataProcesos[j].idSprProceso,
            idSprObjetivo: this.dataProcesos[j].idSprObjetivo,
            idSprTipoProceso: this.dataProcesos[j].idSprTipoProceso,
            idSprMejoras: this.dataProcesos[j].idSprMejoras,
            idSprTipoCliente: this.dataProcesos[j].idSprTipoCliente,
            idSprArea: areaProceso,
            nombre: this.dataProcesos[j].nombre,
            fechaInicio: this.dataProcesos[j].fechaInicio,
            fechaFin: this.dataProcesos[j].fechaFin,
            descripcion: this.dataProcesos[j].descripcion,
            disparador: this.dataProcesos[j].disparador,
            producto: this.dataProcesos[j].producto,
            numeroPersonaAsignada: this.dataProcesos[j].numeroPersonaAsignada,
            tiempoCiclo: this.dataProcesos[j].tiempoCiclo,
            procesoDocumentado: this.dataProcesos[j].procesoDocumentado,
            procesoCertificado: this.dataProcesos[j].procesoCertificado,
            fechaCertificacion: this.dataProcesos[j].fechaCertificacion,
            estado: this.dataProcesos[j].estado,
          })
          areaProceso = [];
        }
      }
    }
    this.dataObjetivoProceso = dataProcess;
    this.reDrawDataTable();
  }

  getIpPublic() {
    this.ip.getIPAddress().subscribe((res: any) => {
      this.ipAddress = res.ip;
    });
  }
  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }

  reDrawDataTable() {
    if (this.isDtInitialized) {
      this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
        dtInstance.destroy();
        this.dtTrigger.next(null);
      });
    } else {
      this.isDtInitialized = true;
      this.dtTrigger.next(null);
    }
  }

  setDataAreasChecked() {
    let areasFixed = this.dataAreas;
    let checked: boolean = false;
    for (let i = 0; i < this.dataAreas.length; i++) {
      for (let j = 0; j < this.dataAreasChecked.length; j++) {
        if (this.dataAreas[i].idSprArea == this.dataAreasChecked[j].idSprArea) {
          checked = true;
        }
      }
      areasFixed[i].checked = checked;
      checked = false;
    }
    this.dataAreasProcess = areasFixed;
  }

  onSubmit() {
    this.formProceso.value.idSprAmbiente = this.idSprAmbiente;
    this.formProceso.value.usuario = this.idSprUsuarioApp;
    this.formProceso.value.ip = this.ipAddress;
    this.formSubmitted = true;
    this.formProceso.value.idSprObjetivo = this.formProceso.value.idSprObjetivo;
    this.onKey(null);
    let stateInsert: boolean = false;
    let idSprProceso = this.formProceso.value.idSprProceso;
    let idSprUsuario = this.idSprUsuarioApp;
    let fechaInicio = this.formProceso.value.fechaInicio;
    let fechaFin = this.formProceso.value.fechaFin;
    let fechaCertificacion = this.formProceso.value.fechaCertificacion;
    // this.validacionFechas(fechaInicio, fechaFin, fechaCertificacion);
    if (this.formProceso.valid && (fechaInicio <= fechaFin)) {
      if (this.formProceso.value.idSprProceso == null || this.formProceso.value.idSprProceso == ' ') {
        let idsAreas = this.formProceso.value.idSprArea;
        stateInsert = true;
        this.procesoService.create(this.formProceso.value).subscribe({
          next: (dataProcesoResponse) => {
            for (let elemento of idsAreas) {
              let dataAreas = {
                idSprProceso: dataProcesoResponse.idSprProceso,
                idSprArea: elemento.idSprArea,
                usuario: this.idSprUsuarioApp,
                ip: this.ipAddress,
                estado: 1,
              };
              this.areaELemService.create(dataAreas).subscribe(
                (dataAreaELemento) => {
                  stateInsert = true;
                },
                (error) => {
                  stateInsert = false;
                }
              );
            }
            let participanteLineaAccion = {
              //idSprParticipanteElemento: this.formProceso.value.idSprParticipanteElemento,
              idSprEquipoGerencial: this.formProceso.value.idSprEquipoGerencial,
              idSprProceso: dataProcesoResponse.idSprProceso,
              fechaInicio: this.formProceso.value.fechaInicio,
              fechaFin: this.formProceso.value.fechaFin,
              ip: this.ipAddress,
              usuario: this.idSprUsuarioApp,
              estado: 1,
            };
            this.participanteElementoService.create(participanteLineaAccion).subscribe(
              (dataParticipantes) => {
                stateInsert = true;
              },
              (error) => {
                stateInsert = false;
              }
            )
            if (stateInsert) {
              this.alert.createOk();
              this.closeModal();
              this.initApp();
            } else {
              this.alert.createError();
            }
            return true;
          },
          error: (err) => {
            stateInsert = false;
          }
        });
      } else {
        this.formProceso.value.ip = this.ipAddress;
        this.formProceso.value.idSprAmbiente = this.idSprAmbiente;
        this.formProceso.value.usuario = this.idSprUsuarioApp;
        stateInsert = true;
        let idsAreasProcesosActuales;

        this.areaELemService.list(`?idSprProceso=${this.formProceso.value.idSprProceso}`).subscribe(
          (data) => {
            idsAreasProcesosActuales = data;
            let idsAreasFormulario = this.formProceso.value.idSprArea;
            this.formProceso.value.ip = this.ipAddress;
            this.formProceso.value.usuario = this.idSprUsuarioApp;
            
              this.procesoService.update(this.formProceso.value).subscribe({
                next: (data) => {

                  for (let i = 0; i < idsAreasFormulario.length; i++) {
                    for (let j = 0; j < idsAreasProcesosActuales.length; j++) {
                      if (idsAreasFormulario[i].checked == false &&
                        idsAreasProcesosActuales[j].idSprArea == idsAreasFormulario[i].idSprArea &&
                        idsAreasProcesosActuales[j].estado == 1) {
                        let dataAtribucionObjetivoActualiza = {
                          idSprAreaElemento: idsAreasProcesosActuales[j].idSprAreaElemento,
                          delLog: 'S',
                          usuario: idSprUsuario,
                          ip: this.ipAddress,
                          estado: 1,
                        };
                        this.areaELemService.update(dataAtribucionObjetivoActualiza).subscribe();
                      }
                    }
                    if (idsAreasFormulario[i].checked == true) {
                      let dataAtribucionObjetivoCreate = {
                        idSprProceso: idSprProceso,
                        idSprArea: idsAreasFormulario[i].idSprArea,
                        usuario: idSprUsuario,
                        ip: this.ipAddress,
                        estado: 1,
                      };
                      this.areaELemService.create(dataAtribucionObjetivoCreate).subscribe();
                    }
                  }
                  let participanteLineaAccion = {
                    idSprParticipanteElemento: this.formProceso.value.idSprParticipanteElemento,
                    idSprEquipoGerencial: this.formProceso.value.idSprEquipoGerencial,          
                    ip: this.ipAddress,
                    usuario: this.idSprUsuarioApp,
                    estado: 1,
                  };
                  this.participanteElementoService.update(participanteLineaAccion).subscribe();
                  this.initApp();
                  this.closeModal();
                  this.alert.updateOk();
                },
                error: (err) => { },
              });           
          },
          (err) => {
            // stateInsert = false;
            this.alert.updateError();
          }
        ); // FIn list areaElementos
      }
    } else {
      return
    }
  }

  getDataParticipanteElemento(idSprProceso: number) {
    this.participanteElementoService.list('?idSprProceso=' + idSprProceso)
      .subscribe((res: any) => {
        this.dataParticipanteElemento = res
        let participanteElementoPatrocinador: any
        this.inputsAnteriores = []
        res.forEach(participante => {
          this.equipoGerencialService.getById(participante.idSprEquipoGerencial).subscribe((resi: any) => {
            this.patrocinadorOriginal = participante
            participanteElementoPatrocinador = resi
            this.guardarEquipoGerencialSeleccionado = resi
            this.formProceso.patchValue({
              ...this.formProceso.value,
              idSprEquipoGerencial: resi.idSprEquipoGerencial,
              idSprParticipanteElemento: participante.idSprParticipanteElemento
            })
            this.formProceso.value.idSprEquipoGerencial = resi.idSprEquipoGerencial
            this.formProceso.value.idSprParticipanteElemento = participante.idSprParticipanteElemento
            this.idSprParticipanteElemento = participante.idSprParticipanteElemento;
          })
        })
      })
  }



  validacionFechas(fecha1: Date, fecha2: Date, fecha3: Date) {
    let alerta1
    let alerta2
    if (fecha1 > fecha2) {
      alerta1 = this.alert.warning(
        '¡Atención!',
        'Fecha inicio no puede ser mayor a la fecha fin'
      );
      return alerta1
    }
    if (fecha2 > fecha3) {
      alerta2 = this.alert.warning(
        '¡Atención!',
        'Fecha fin no puede ser mayor a la fecha certificación'
      );
      return alerta2
    }
  }

  obtenerObjetivo(idSprObjetivo: any): any {
    for (let obj of this.dataObjetivo) {
      if (obj.idSprObjetivo == idSprObjetivo) {
        return obj;
      }
    }
    return null;
  }

  update(obj: any) {
    //CODIGO PARA RESTABLECER EL SCROLL DE UN MODAL
    setTimeout(() => {
      // Verificar que la referencia al modal existe
      if (this.myModal) {
        const scrollableElement = this.myModal.element.querySelector(
          '.modal-dialog-scrollable .modal-body'
        );
        // Verificar que el elemento scrollable existe
        if (scrollableElement) {
          scrollableElement.scrollTop = 0;
        } else {
        }
      } else {
      }
    }, 200);

    this.onResetForm();
    this.getDataAll();
    this.openModal();
    this.dataAreasChecked = obj.idSprArea;
    this.setDataAreasChecked();
    this.addItemChecked(obj.idSprArea);
    this.getDataParticipanteElemento(obj.idSprProceso)

    this.formProceso.patchValue({
      idSprProceso: obj.idSprProceso,
      idSprObjetivo: obj.idSprObjetivo,
      //idSprEstrategia: obj.idSprEstrategia,
      idSprEquipoGerencial: obj.idSprEquipoGerencial,
      //idSprEquipoGerencialAnterior: obj.idSprEquipoGerencial,
      idSprParticipanteElemento: obj.idSprParticipanteElemento,
      idSprMejoras: obj.idSprMejoras,
      idSprTipoProceso: obj.idSprTipoProceso,
      idSprTipoCliente: obj.idSprTipoCliente,
      idSprAreaProceso: obj.idSprAreaProceso,
      idSprArea: obj.idSprArea,
      nombre: obj.nombre,
      descripcion: obj.descripcion,
      disparador: obj.disparador,
      producto: obj.producto,
      fechaInicio: obj.fechaInicio,
      fechaFin: obj.fechaFin,
      tiempoCiclo: obj.tiempoCiclo,
      numeroPersonaAsignada: obj.numeroPersonaAsignada,
      procesoDocumentado: obj.procesoDocumentado,
      procesoCertificado: obj.procesoCertificado,
      fechaCertificacion: obj.fechaCertificacion,
      estado: obj.estado,
    });
  }

  delete(idRegister: number) {
    this.modal.open('delete');
    this.idDeleteRegister = idRegister;
  }

  verifyIndicador() {
    return this.indicadoresService
      .list(`?idSprProceso=${this.idDeleteRegister}&delLog=N`)
      .toPromise();
  }

  verifyDesempenioProceso() {
    return this.desempenioProcesoService
      .list(`?idSprProceso=${this.idDeleteRegister}&delLog=N`)
      .toPromise();
  }

  async confirmDelete() {
    let errorDeleteState: boolean = false;
    let dataDeleteAreElementos = {
      usuario: this.idSprUsuarioApp,
      idSprAreaElemento: 0,
      ip: this.ipAddress,
      delLog: 'S',
    };
    let dataDeleteParticipElementos = {
      usuario: this.idSprUsuarioApp,
      idSprParticipanteElemento: 0,
      ip: this.ipAddress,
      delLog: 'S',
    };
    let dataDeleteProceso = {
      idSprProceso: this.idDeleteRegister,
      usuario: this.idSprUsuarioApp,
      ip: this.ipAddress,
      delLog: 'S',
    };

    let confirmDelete = true;
    let dataVerifyRelacion: any = [];
    //##############  verificacion1 si existe datos relacionado ########################
    dataVerifyRelacion = await this.verifyIndicador();
    dataVerifyRelacion.length > 0 ? (confirmDelete = false) : '';
    //###################################################################################
    //##############  verificacion2 si existe datos relacionado ########################
    dataVerifyRelacion = await this.verifyDesempenioProceso();
    dataVerifyRelacion.length > 0 ? (confirmDelete = false) : '';
    //###################################################################################

    if (confirmDelete) {
      let areasELementos = [];
      let participantesElementos = [];
      this.participanteElementoService
        .list(`?idSprProceso=${this.idDeleteRegister}`)
        .subscribe((response) => {
          participantesElementos = response;
          this.areaELemService
            .list(`?idSprProceso=${this.idDeleteRegister}`)
            .subscribe((response) => {
              areasELementos = response;
              // Foreach 1

              //if(areasELementos){
              areasELementos.forEach((itemAreaElement) => {
                dataDeleteAreElementos.idSprAreaElemento =
                  itemAreaElement.idSprAreaElemento;
                this.areaELemService.delete(dataDeleteAreElementos).subscribe({
                  next: (responseDelete) => { },
                  error: (error) => {
                    errorDeleteState = true;
                    dataDeleteProceso.delLog = 'N';
                    this.procesoService.delete(dataDeleteProceso).subscribe({
                      next: (responseDelete) => { },
                      error: (error) => {
                        errorDeleteState = true;
                      },
                    });
                  },
                });
              }); // Fin forEach 1
              // }
              // Foreach 2
              //if(participantesElementos){
              participantesElementos.forEach((itemParticipanteElement) => {
                dataDeleteParticipElementos.idSprParticipanteElemento =
                  itemParticipanteElement.idSprParticipanteElemento;
                this.participanteElementoService
                  .delete(dataDeleteParticipElementos)
                  .subscribe({
                    next: (responseDelete) => { },
                    error: (error) => {
                      errorDeleteState = true;
                      dataDeleteProceso.delLog = 'N';
                      this.procesoService.delete(dataDeleteProceso).subscribe({
                        next: (responseDelete) => { },
                        error: (error) => {
                          errorDeleteState = true;
                        },
                      });
                    },
                  });
              }); // Fin forEach 2
              // }
            });
        });

      if (!errorDeleteState) {
        this.procesoService.delete(dataDeleteProceso).subscribe({
          next: (responseDelete) => { },
          error: (error) => {
            errorDeleteState = true;
          },
        });
      }
      if (!errorDeleteState) {
        this.alert.deleteOk();
        this.modal.close();
        this.initApp();
      } else {
        this.alert.deleteError();
      }
    } else {
      this.alert.EliminarRegistro();
    }
  }

  //Detalle Proceso
  desempenioInit(obj: any) {
    this.desripcionProceso = obj.nombre;
    this.desempenio = obj;
    this.openModalDesempenio();
  }

  listAreas() {
    this.areaServcie.list('?idSprAmbiente=' + this.idSprAmbiente).subscribe((resp) => {
      this.dataAreas = resp;
      this.setDataAreasChecked();
    });
  }

  getParticipanteElemento() {
    this.participanteElementoService.list().subscribe((resp) => {
      this.dataPersonalElementoP = resp;
      this.getEquipoGerencial();
    })
  }

  getEquipoGerencial() {
    this.equipoGerencialService.list().subscribe((resp) => {
      this.dataEquipoGerencial = resp;
      //this.mapDataLineasObjetivos()
    })
  }

  getDataParticipantes() {
    this.equipoGerencialService.list(
      `?idSprAmbiente=${this.idSprAmbiente}&idSprTipoParticipante=${this.idRolResponsable}&estado=${1}`)
      .subscribe(
        (resp) => {
          this.dataParticipantesElemento = resp
        });
  }

  onChange(event: any, id: any) {
    let indice = -1;
    for (let i = 0; i < this.opciones.length; i++) {
      if (this.opciones[i].idSprArea === id) {
        indice = i;
        break; // Si encuentra sale del bucle
      }
    }
    if (indice === -1) {
      this.opciones.push({
        idSprArea: id,
        checked: event.target.checked,
      });
    } else {
      this.opciones.splice(indice, 1);
    }
    this.formProceso.value.idSprArea = this.opciones;
  }

  onChangeObjetivo(event: any) {
    if (event) {
      this.objetivoSeleccionadoCombo = event;
    }
  }

  addItemChecked(arreglo: any) {
    //vaciar el arreglo
    const idsSprArea: FormArray = this.formProceso.get('idSprArea') as FormArray;
    idsSprArea.removeAt(null);
    for (let i = 0; i < arreglo.length; i++) {
      const idSprArea: FormArray = this.formProceso.get('idSprArea') as FormArray;
      idSprArea.push(new FormControl(arreglo[i].idSprArea + ' '));
    }
  }

  openFechaCertificacion(event: any) {
    if (event) {
      if (event == 1) {
        this.openFechaCertifi = true;
      } else {
        this.openFechaCertifi = false;
      }
    }
  }

  listTipoCliente() {
    this.comunService
      .list('?spr_idSprComun=' + this.idRecursivoCliente)
      .subscribe((resp) => {
        this.dataCatComun = resp;
      });
  }

  listTipoProceso() {
    this.especialUnoService
      .list('?spr_idSprEspecialUno=' + this.idSprTipoProceso)
      .subscribe((resp) => {
        this.dataTipoProceso = resp;
      });
  }

  listMejoras() {
    this.comunService
      .list('?spr_idSprComun=' + this.idRecursivoMejoras)
      .subscribe((resp) => {
        this.dataMejoras = resp;
      });
  }

  /*CONTADOR DE CARACTER**/
  onKey(event: Event) {
    let maxLength = 3000;
    let strLength = this.textoAreaValue.length;
    let charRemain = maxLength - strLength;

    if (charRemain < 0) {
      document.getElementById('contador').innerHTML =
        '<span style="color: red;"> Ha superado el límite de ' +
        maxLength +
        ' characters</span>';
    } else {
      document.getElementById('contador').innerHTML =
        charRemain + ' caracteres restantes';
    }
    this.contador = charRemain; // Actualizar el contador cada vez que se pulsa una tecla
  }
  /****/

  /*CONTADOR DE CARACTER**/
  onKey1(event: Event) {
    let maxLength = 500;
    let strLength = this.textoAreaValue1.length;
    let charRemain = maxLength - strLength;

    if (charRemain < 0) {
      document.getElementById('contador1').innerHTML =
        '<span style="color: red;"> Ha superado el límite de ' +
        maxLength +
        ' characters</span>';
    } else {
      document.getElementById('contador1').innerHTML =
        charRemain + ' caracteres restantes';
    }

    this.contador1 = charRemain; // Actualizar el contador cada vez que se pulsa una tecla
  }
  /****/

  /**CONTADOR DE CARACTER***/
  // Modal Crear/editar
  openModal() {
    //this.dataAreasChecked = [];
    this.onResetForm(),
      this.modal.open(this.nameModal);

    setTimeout(() => {//CODIGO PARA RESTABLECER EL SCROLL DE UN MODAL
      // Verificar que la referencia al modal existe
      if (this.myModal) {
        const scrollableElement = this.myModal.element.querySelector(
          '.modal-dialog-scrollable .modal-body'
        );
        // Verificar que el elemento scrollable existe
        if (scrollableElement) {
          scrollableElement.scrollTop = 0;
        } else {
        }
      } else {
      }
    }, 200);

    this.textoAreaValue = ''; // Restablecer el valor del ngModel a una cadena vacía
    this.contador = 3000; // Reiniciar el contador a 700 cada vez que se abre el modal
    this.onKey(null);
    this.textoAreaValue1 = ''; // Restablecer el valor del ngModel a una cadena vacía
    this.contador1 = 500; // Reiniciar el contador a 500 cada vez que se abre el modal
    this.onKey1(null);
  }

  closeModal() {
    this.listAreas()
    this.opciones = [];
    this.dataAreasChecked = [];
    this.setDataAreasChecked();
    this.modal.closeId(this.nameModal);
  }

  openModalDesempenio() {
    this.onResetForm();
    this.modal.open(this.modalDesempenioProceso);
  }

  closeModalDesempenio() {
    this.desempenio = null;
    this.modal.closeId(this.modalDesempenioProceso);
  }

  onResetForm() {
    this.formSubmitted = false;
    this.formProceso.reset();
    this.objetivoSeleccionadoCombo = null;
  }
}
